import { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { initialValues } from "../../modules/dialogs/Filters/utils";
import { useRoot } from "../../../context/root";
import { useMap } from "../../../context/map";

export const useCategoryFilters = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { rootDispatch } = useRoot();
  const { mapContext } = useMap();
  const { geohash } = useParams();
  const [activeCategory, setActiveCategory] = useState(() => {
    const itemTypeFromParam = searchParams.get("item_type");
    if (itemTypeFromParam) {
      return itemTypeFromParam
    }
    return "all"
  });

  useEffect(() => {
    const el = document.getElementById(`tab-${activeCategory}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }, [activeCategory]);

  const handleChangeCategory = (category: { id: string, label: string, value: string }) => {
    if (category.id === activeCategory || category.id === "all") {
      setActiveCategory("all");
      searchParams.delete("item_type");
    }
    else {
      searchParams.set("item_type", category.value)
      setActiveCategory(category.value);
    }
    rootDispatch({
      type: "setDataList",
      data: []
    });
    rootDispatch({
      type: "setDataMarkers",
      data: []
    });
    rootDispatch({
      type: "setExtraMarker",
      data: null,
      mapContext
    });
    Object.keys(initialValues).map((key) => {
      searchParams.delete(key)
    })
    if (geohash) {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}bucket/${geohash}`,
        search: searchParams.toString()
      })
    }
    else {
      navigator({
        pathname: `${process.env.REACT_APP_INTERNAL_URL}`,
        search: searchParams.toString()
      })
    }
    rootDispatch({
      type: "setRefetch",
      data: {
        shouldRefetch: true,
        geohash: geohash || null
      }
    })
  }

  return {
    activeCategory,
    handleChangeCategory,
    claimActive: !!searchParams.get("claim")
  }
}
